// NIL store constants and the profit rule — client-safe (the product page
// shows "You earn" with the same function the order webhook books with).

// Card processing comes out of the athlete's profit (Shopify Payments, Basic
// plan: 2.9% + 30¢). Only the percentage is passed on for now; set the fixed
// part above 0 to pass that on as well (it is charged per order, so the
// ledger applies it once per order line, an over-estimate for multi-item carts).
export const NIL_CARD_FEE_PCT = 2.9;
export const NIL_CARD_FEE_FIXED = 0;

// Days after an order before its profit can be paid out (returns/chargebacks).
export const NIL_PAYOUT_HOLD_DAYS = 30;

export const NIL_PAYOUT_METHODS = [
  { id: "paypal", label: "PayPal", handle: "PayPal email" },
  { id: "venmo",  label: "Venmo",  handle: "Venmo username" },
  { id: "zelle",  label: "Zelle",  handle: "Zelle email or phone" },
];

// The cookie that puts the print flow in NIL mode (set by /nil, cleared by
// /start/<entry>). Readable by the browser: the product page checks it.
export const NIL_MODE_COOKIE = "rg_nil";

// Which of the customer's stores Add to Store fills: a team store's slug, set
// by /team/start and the team store's Add Products. Unset = their NIL store.
// Cleared by /nil and /start/<entry>.
export const NIL_STORE_COOKIE = "rg_nil_store";

/** Store page path: athlete stores at /NIL/<slug>, team stores at /team/<slug>. */
export function nilStorePath(kind, slug) {
  return kind === "team" ? `/team/${slug}` : `/NIL/${slug}`;
}

const cents = (n) => Math.round(Number(n) * 100) / 100;

/** Card fee on `price` (per unit). */
export function nilFee(price) {
  return cents(Number(price) * NIL_CARD_FEE_PCT / 100 + NIL_CARD_FEE_FIXED);
}

/** The athlete's profit per unit sold at `price` on a variant costing `basePrice`. */
export function nilProfit(price, basePrice) {
  return cents(Number(price) - Number(basePrice) - nilFee(price));
}

/** A starting price: about $9 over base, ending in .99. */
export function nilSuggestedPrice(basePrice) {
  return cents(Math.ceil(Number(basePrice) + 9) - 0.01);
}

/** "NIL Premium Unisex T Shirt" → "Premium Unisex T Shirt". */
export function nilDisplayName(title) {
  return String(title || "").replace(/^\s*NIL\s+/i, "").trim();
}

export function nilModeFromCookie() {
  if (typeof document === "undefined") return false;
  return document.cookie.split(/;\s*/).some((c) => c === `${NIL_MODE_COOKIE}=1`);
}

export function nilStoreFromCookie() {
  if (typeof document === "undefined") return null;
  const hit = document.cookie.split(/;\s*/).find((c) => c.startsWith(`${NIL_STORE_COOKIE}=`));
  return hit ? decodeURIComponent(hit.slice(NIL_STORE_COOKIE.length + 1)) || null : null;
}

/** Point Add to Store at a team store (slug), or back at the NIL store (null). */
export function setNilStoreCookie(slug) {
  try {
    document.cookie = slug
      ? `${NIL_STORE_COOKIE}=${encodeURIComponent(slug)}; path=/; samesite=lax; secure`
      : `${NIL_STORE_COOKIE}=; path=/; max-age=0; samesite=lax; secure`;
  } catch {}
}
